<template>
  <login-panel class="temporary-password" xs>
    <div class="temporary-password__content">
      <h3 class="temporary-password__title">
        {{ $t('login.temporary-access') }}
      </h3>
      <p class="temporary-password__description" v-html="$t('login.temporary-access-text')"></p>
      <p class="temporary-password__description">
        <strong>
          {{ $t('login.password-conditions') }}
        </strong>
      </p>
      <new-password-form></new-password-form>
    </div>
  </login-panel>
</template>

<script>
import LoginPanel from '@/components/LoginPanel';
import NewPasswordForm from '@/domain/components/login/register/NewPasswordForm';

export default {
  components: {
    LoginPanel,
    NewPasswordForm,
  },
};
</script>

<style lang="sass" scoped>

.temporary-password
  &__content
    display: flex
    flex-direction: column
  &__title
    font-weight: 600
    font-size: 1.1em
    text-transform: uppercase
    text-align: center
    margin-bottom: 20px
  &__description
    text-align: center
</style>
